let Search = {
    init: function () {
        if ($('body.search').length) {
            this.bind();
        }
    },

    bind: function () {
        this.listenForFieldChanges();
        this.toggleFields();
    },

    listenForFieldChanges() {
        let _this = this;

        $(document).on('change', '.status_aeo', function () {
            _this.toggleFields();
        });
        $(document).on('change', '.status_mra', function () {
            _this.toggleFields();
        });
        $(document).on('change', '.status_cmaa', function () {
            _this.toggleFields();
        });
        $(document).on('change', '.status_ccp', function () {
            _this.toggleFields();
        });
        $(document).on('change', '.type_aeo', function () {
            _this.toggleFields();
        });
    },
    toggleFields() {

        if ($('#status_operational_aeo').prop('checked') && $('#status_development_aeo').prop('checked')){
            $('#launchDateContainer').show();
            $('#aeoOperatorsNumberContainer').show();
            $('#furtherPlansContainer').show();
            $('#mraOperatorsNumberContainer').show();
            $('#implementationPlanContainer').show();
        } else if ($('#status_development_aeo').prop('checked')){
            $('#launchDateContainer').hide();
            $('#aeoOperatorsNumberContainer').hide();
            $('#furtherPlansContainer').hide();
            $('#mraOperatorsNumberContainer').hide();
            $('#implementationPlanContainer').show();
        } else if ($('#status_operational_aeo').prop('checked')) {
            $('#launchDateContainer').show();
            $('#aeoOperatorsNumberContainer').show();
            $('#furtherPlansContainer').show();
            $('#implementationPlanContainer').hide();
            $('#mraOperatorsNumberContainer').hide();
        } else {
            $('#launchDateContainer').hide();
            $('#aeoOperatorsNumberContainer').hide();
            $('#furtherPlansContainer').hide();
            $('#mraOperatorsNumberContainer').hide();
            $('#implementationPlanContainer').hide();
        }

        if ($('#status_operational_aeo').prop('checked') && $('#type_multi_tier_aeo').prop('checked')) {
            $('#mraOperatorsNumberContainer').show();
        } else {
            $('#mraOperatorsNumberContainer').hide();
        }

        if ($('#status_operational_ccp').prop('checked') && $('#status_development_ccp').prop('checked')){
            $('#launchDateContainer_ccp').show();
            $('#mraOperatorsNumberContaine_ccp').show();
            $('#implementationPlanContainer_ccp').show();
        } else if ($('#status_operational_ccp').prop('checked')) {
            $('#launchDateContainer_ccp').show();
            $('#mraOperatorsNumberContaine_ccp').show();
            $('#implementationPlanContainer_ccp').hide();
        } else if ($('#status_development_ccp').prop('checked')){
            $('#launchDateContainer_ccp').hide();
            $('#mraOperatorsNumberContaine_ccp').hide();
            $('#implementationPlanContainer_ccp').show();
        } else{
            $('#launchDateContainer_ccp').hide();
            $('#mraOperatorsNumberContaine_ccp').hide();
            $('#implementationPlanContainer_ccp').hide();
        }

        if ($('#status_signed_mra').prop('checked') || $('#status_operational_mra').prop('checked')) {
            $('#dateSignedContainer_mra').show();
        } else {
            $('#dateSignedContainer_mra').hide();
        }

        if ($('#status_signed_cmaa').prop('checked') || $('#status_operational_cmaa').prop('checked')) {
            $('#dateSignedContainer_cmaa').show();
        } else {
            $('#dateSignedContainer_cmaa').hide();
        }

    },

};

$().ready(() => {
    window.Search = Search;
    window.Search.init();
});
